

const H2Tag = ({ text = '', className = '' }) => {
    /* ----------------------------- Start variables ---------------------------- */
    /* -------------------------------------------------------------------------- */
    return <h2 className={`${className} w-full mb-2 text-xl md:text-3xl text-[#093686] font-brandingBold`}>{text}</h2>
};

export default H2Tag;
